import React from 'react'
import { Link } from 'react-router-dom'

import Avatar from '../../../../../../UI/Avatar'
import { imagePrefix } from '../../../../../../../constants'

const TopTutor = ({ tutor }) => {
  return (
    <div className="border-2 borderViewLightPink px-[10px] py-[8px]">
      <div className="flex justify-between items-center">
        <div className="flex justify-center items-center">
          <Avatar
            src={tutor.tutor_pic ? `${imagePrefix}${tutor.tutor_pic}` : ''}
            alt={tutor.tutor_name}
            className="w-[36px] h-[36px]"
          />

          <div className="flex items-start flex-col ml-[12px] flex-1">
            <h6 className="w-[90%] text-[#F67443] text-base font-semibold mb-[4px] font-Inter">
              {tutor.tutor_name}
            </h6>

            <div className="flex items-center gap-x-[10px]">
              <div className="flex justify-center items-center">
                <img
                  className="w-[16px] h-[16px]"
                  src={'/assets/icon/checkbox-multiple-line.svg'}
                  alt="Check"
                />
                <span className="text-[#F67443] font-Inter font-medium ml-1 text-xs">
                  {tutor.total_bookings}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <img className="w-[16px] h-[16px]" src={'/assets/icon/user-green.svg'} alt="User" />
                <span className="text-[#F67443] font-Inter font-medium ml-1 text-xs">
                  {tutor.total_students}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <img className="w-[16px] h-[16px]" src={'/assets/icon/star.svg'} alt="Star" />
                <span className="text-[#F67443] font-Inter font-medium ml-1 text-xs">
                  {tutor.overall_rating_average}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <span className="text-[#B733DD] text-xs font-bold">ROI</span>
                {/* TODO: make dynamic data */}
                <span className="text-[#F67443] font-medium ml-1 font-Inter text-xs">{0}%</span>
              </div>

              <div className="flex justify-center items-center">
                <img className="w-[16px] h-[16px]" src={'/assets/icon/euro-coin.svg'} alt="Coin" />
                {/* TODO: make dynamic data */}
                <span className="text-[#F67443] font-medium ml-1 text-xs font-Inter">{0}</span>
              </div>
            </div>
          </div>
        </div>

        <Link
          to="/"
          className="mb-auto flex items-center px-[4px] text-center text-[#F79009] hover:text-[#F79009] h-[22px] font-medium roiBorder rounded-[4px] text-[10px] font-Inter"
        >
          See Profile
        </Link>
      </div>
    </div>
  )
}

export default TopTutor
